import {
  Component,
  OnInit,
  ViewChildren,
  QueryList,
  AfterViewInit,
} from '@angular/core';
import { AppComponent } from 'src/app/app.component';
declare var $;
import { NavService } from 'src/app/_services/nav.service';
import { SortService } from 'src/app/_services/sort.service';
import {
  NgbdSortableHeader,
  SortColumn,
  SortDirection,
  SortEvent,
} from './sortable.directive';
import { IrmReportService } from 'src/app/_services/irmReport.service';
import { pickBy, identity } from 'lodash';
import { IrmReport } from 'src/models/irmReport.model';
import { IrmLabel } from 'src/models/irmLabel.model';
import { CompanyService } from 'src/app/_services/company.service';
import { ToastrService } from 'src/app/_services/toastr.service';
import { TranslateService } from '@ngx-translate/core';
import { SyncService } from 'src/app/_services/sync.service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { LogPopupComponent } from './components/log-popup/log-popup.component';
import { HttpResponse } from '@angular/common/http';
import { PopupDeleteComponent } from '../descargas/delete-popup.component';

declare var bootstrapSelect: any;

@Component({
  selector: 'logs',
  templateUrl: './logs.component.html',
  styleUrls: ['./logs.component.css'],
})
export class LogsComponent implements OnInit {
  REPORTS: IrmReport[] = [];

  data: { title: 'Informes' };
  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;

  reports: IrmReport[];
  page = 1;
  pageSize = 10;
  collectionSize = this.REPORTS?.length;

  sortColumn: SortColumn;
  sortDirection: SortDirection;

  sortState: any;

  user: string;
  selectedActions: any[] = [];
  selectedUsers: any[] = [];
  selectedDeptos: any[] = [];
  selectedLabels: any[] = [];
  minDate: any;
  maxDate: any;
  rangeDate: any;
  maxDateInput: Date = new Date();

  actions: string[] = [];
  users: string[] = [];
  labels: IrmLabel[] = [];
  labelsName: string[] = [];
  departments: string[] = [];

  areFiltersCollapsed = false;

  isLoading: boolean = true;

  filters: any;

  maxLength: number = 50;

  todasLasOpciones: [] = [];
  canSync: boolean = false;
  lastSync: string;

  protected ngbModalRef: NgbModalRef;

  // tslint:disable-next-line: max-line-length
  constructor(
    private appComponent: AppComponent,
    private navService: NavService,
    private sortService: SortService,
    private irmReportService: IrmReportService,
    private companyService: CompanyService,
    private toastrService: ToastrService,
    private translate: TranslateService,
    private syncService: SyncService,
    private modalService: NgbModal
  ) {
    Window['appuser'] = this;
  }

  ngOnInit() {
    this.isLoading = true;
    const today = new Date();
    this.maxDate = today;
    this.minDate = new Date(today);
    this.minDate.setDate(this.minDate.getDate() - 30);
    this.setFilters();
    this.getActions();
    this.getUsers();

    this.selectedNavItem({
      parent: 'record.report',
      child: 'menu.reports.logs',
      description: 'pageDescriptions.logs',
    });

    this.syncService.getLastSync().subscribe((res) => {
      this.lastSync = this.formatDate(res?.body?.lastModifiedDate);
    });
    this.syncService.canSync().subscribe((res) => {
      this.canSync = res.body;
    });
  }

  formatDateSync(initDate) {
    const date = new Date(initDate);

    const day = this.padZero(date.getDate());
    const month = this.padZero(date.getMonth() + 1);
    const year = date.getFullYear();
    const hours = this.padZero(date.getHours());
    const minutes = this.padZero(date.getMinutes());

    return `${day}/${month}/${year} ${hours}:${minutes}`;
  }

  padZero(num: number): string {
    return num < 10 ? '0' + num : num.toString();
  }

  formatDate(selectedDate: Date): string {
    const day = selectedDate.getDate().toString().padStart(2, '0');
    const month = (selectedDate.getMonth() + 1).toString().padStart(2, '0');
    const year = selectedDate.getFullYear().toString().substring(2);

    return `${day}.${month}.${year}`;
  }

  setFilters() {
    const filters = {
      users: this.selectedUsers?.length > 0 ? this.selectedUsers : [],
      sections: this.selectedActions?.length > 0 ? this.selectedActions : [],
      lastModifiedDateFrom: this.minDate && this.minDate,
      lastModifiedDateTo: this.maxDate && this.maxDate,
    };
    this.filters = {
      ...filters,
      sort: this.sortState?.sort,
      order: this.sortState?.order,
    };
    this.filters = pickBy(this.filters, (v) => v !== undefined);
    this.page = 1;
    this.refreshReports();
  }

  cleanFilters() {
    const today = new Date();
    this.maxDate = today;
    this.minDate = new Date(today);
    this.minDate.setDate(this.minDate.getDate() - 30);
    this.user = undefined;
    this.selectedActions = undefined;
    this.selectedDeptos = undefined;
    this.selectedUsers = undefined;
    this.filters = undefined;
    this.rangeDate = undefined;
    this.filters = {
      ...this.filters,
      sort: this.sortState?.sort,
      order: this.sortState?.order,
    };
    this.filters = pickBy(this.filters, (v) => v !== undefined);
    this.page = 1;
    this.setFilters();
  }

  refreshReports() {
    this.isLoading = true;
    this.syncService
      .getAllSyncs(this.page - 1, this.filters, this.pageSize)
      .subscribe(
        (res) => {
          this.isLoading = false;
          this.collectionSize = res['total'];
          this.reports = res['results'];
        },
        (err) => (this.isLoading = false)
      );
  }

  getActions() {
    this.syncService.getSections().subscribe((res) => {
      this.actions = res.body;
    });
  }

  getUsers() {
    this.syncService.getUsers().subscribe((res) => {
      this.users = res.body;
    });
  }

  getLabels() {
    this.irmReportService.getLabels().subscribe((res) => {
      this.labels = res.body;
      this.labelsName = this.labels.map((label) => label.name);
    });
  }

  getDepartments() {
    this.companyService.getDepartments().subscribe((res) => {
      this.todasLasOpciones = res.body;
      this.departments = this.todasLasOpciones.slice(0, 20);
    });
  }

  cargarMasOpciones() {
    const inicio = this.departments?.length;
    const fin = inicio + 20;
    this.departments = this.departments.concat(
      this.todasLasOpciones.slice(inicio, fin)
    );
  }

  download() {
    this.syncService
      .download(this.filters)
      .subscribe((response: HttpResponse<Blob>) => {
        this.createDownloadLink(response);
      });
  }

  createDownloadLink(response: HttpResponse<Blob>) {
    let filename = 'logHistory.xlsx'; // Nombre de archivo por defecto
    const contentDispositionHeader = response.headers.get(
      'Content-Disposition'
    );
    if (contentDispositionHeader) {
      const matches = /filename="?([^"]+)"?;?/i.exec(contentDispositionHeader);
      filename = matches && matches.length > 1 ? matches[1] : filename;
    } else if (response.url) {
      const urlParts = response.url.split('/');
      filename = urlParts[urlParts.length - 1];
    }

    const blob = new Blob([response.body], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = filename;

    document.body.appendChild(link);
    link.click();

    URL.revokeObjectURL(url);
    document.body.removeChild(link);
  }

  seeDetails(message, id) {
    this.ngbModalRef = this.modalService.open(LogPopupComponent, {
      backdrop: 'static',
      centered: true,
      windowClass: 'modal-holder',
    });
    this.ngbModalRef.componentInstance.message = message;
    this.ngbModalRef.componentInstance.id = id;
    this.ngbModalRef.result.then(
      (result) => {},
      (err) => {
        window.console.log('err');
      }
    );
  }

  generateGeneralIrmReport() {
    this.toastrService.info(this.translate.instant('onProcessGeneratngReport'));
    this.irmReportService.generateGeneralIrmReport(this.filters, this.translate.currentLang)
      .subscribe((res) => {}, (error) => { this.toastrService.error(this.translate.instant('errorReport')); });
  }

  generateEvoIrmReport() {
    this.toastrService.info(this.translate.instant('onProcessGeneratngReport'));
    this.irmReportService.generateEvoIrmReport(this.filters, this.translate.currentLang)
      .subscribe((res) => {}, (error) => { this.toastrService.error(this.translate.instant('errorReport')); });
  }

  onSort({ column, direction }: SortEvent) {
    // resetting other headers
    this.headers.forEach((header) => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });
    this.sortColumn = column;
    this.sortDirection = direction;

    if (this.sortDirection !== '') {
      this.filters = {
        ...this.filters,
        sort: this.sortColumn,
        order: this.sortDirection,
      };
      this.sortState = {
        sort: this.sortColumn,
        order: this.sortDirection,
      };
    } else {
      delete this.filters.sort;
      delete this.filters.order;
      this.sortState = undefined;
    }
    this.refreshReports();
  }

  selectedNavItem(data: any) {
    this.navService.emitNavChangeEvent(data);
  }

  setDate(event) {
    this.minDate = event[0];
    this.maxDate = event[1];
  }

  syncUp() {
    this.ngbModalRef = this.modalService.open(PopupDeleteComponent, {
      backdrop: 'static',
      centered: true,
      windowClass: 'modal-holder',
    });
    this.ngbModalRef.componentInstance.isConfirmAction = true;
    this.ngbModalRef.result.then(
      (result) => {
        this.syncService.syncUp().subscribe((response) => {
          this.syncService.getLastSync().subscribe((res) => {
            this.lastSync = this.formatDateSync(res?.body?.lastModifiedDate);
          });
          this.syncService.canSync().subscribe((res) => {
            this.canSync = !res.body;
          });
        });
      },
      (err) => {
        window.console.log('err');
      }
    );
  }
}
